export const localize: Record<string, string> = {
  'localize.title': 'Đa ngôn ngữ Video',
  'localize.uploadBtn': 'Tải video lên',
  'localize.refreshBtn': 'Làm mới',
  'localize.owner': 'Người tạo',

  'localize.worker.online': 'Worker: Online',
  'localize.worker.offline': 'Worker: Offline',
  'localize.worker.lastSeen': 'Lần cuối hoạt động',
  'localize.worker.never': 'Chưa hoạt động',

  'localize.filter.all': 'Tất cả',
  'localize.status.pending': 'Đang chờ',
  'localize.status.claimed': 'Đã nhận',
  'localize.status.processing': 'Đang xử lý',
  'localize.status.paused': 'Tạm dừng',
  'localize.status.completed': 'Hoàn thành',
  'localize.status.failed': 'Lỗi',
  'localize.status.cancelled': 'Đã hủy',

  'localize.empty': 'Chưa có công việc nào.',
  'localize.created': 'Ngày tạo',
  'localize.elapsed': 'Thời gian',
  'localize.queue': 'Hàng đợi',

  'localize.action.retry': 'Thử lại',
  'localize.action.pause': 'Tạm dừng',
  'localize.action.resume': 'Tiếp tục',
  'localize.action.cancel': 'Hủy',
  'localize.action.cancelConfirm': 'Hủy công việc này? Kết quả đã render được giữ lại.',
  'localize.action.delete': 'Xóa',
  'localize.action.deleteConfirm': 'Xóa công việc và toàn bộ file liên quan? Không thể hoàn tác.',

  'localize.modal.title': 'Tải video lên để đa ngôn ngữ',
  'localize.modal.video': 'File video (mp4/mov, tối đa 500MB)',
  'localize.modal.slug': 'Nhãn ngắn (slug)',
  'localize.modal.slugHint': 'Ví dụ: myapp-launch',
  'localize.modal.sourceLang': 'Ngôn ngữ gốc',
  'localize.modal.sourceLangAuto': 'Tự động nhận diện',
  'localize.modal.targetLangs': 'Ngôn ngữ đích (tối đa 20)',
  'localize.modal.tone': 'Giọng điệu',
  'localize.modal.tone.cheerful': 'Vui vẻ',
  'localize.modal.tone.serious': 'Nghiêm túc',
  'localize.modal.tone.excited': 'Hào hứng',
  'localize.modal.tone.neutral': 'Trung tính',
  'localize.modal.burnSubs': 'Chèn phụ đề cứng vào video',
  'localize.modal.compliance': 'Tôi xác nhận video này tuân thủ chính sách nội dung',
  'localize.modal.submit': 'Tạo công việc',
  'localize.modal.submitting': 'Đang tải lên…',
  'localize.modal.cancel': 'Hủy',
  'localize.modal.errorNoLangs': 'Chọn ít nhất 1 ngôn ngữ đích',
  'localize.modal.errorNoFile': 'Chọn file video',
  'localize.modal.errorCompliance': 'Cần xác nhận tuân thủ chính sách',
};
